import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";
import { Form, useLocation } from "react-router-dom";
import { fetch_event } from "../api/event";
import RSVPForm from "../components/RSVPForm";
import moment from "moment";
import REMAEventDetails from "../components/REMA/REMAEventDetails";
import Footer from "../components/REMA/Footer";
import MobileFooter from "../components/REMA/MobileFooter";
import FormPageNavbar from "../components/REMA/FormPageNavbar";

const EventDetails = (props) => {
  return (
    <div className="bg-light-green-100 md:h-auto relative overflow-hidden rounded-lg max-w-[595px] md:w-2/5 flex flex-col justify-center md:justify-start">
      {Boolean(props.event?.invitation_file?.length) && (
        <img
          src={props.event?.invitation_file}
          className="w-full self-center rounded-lg"
        />
      )}
      <p className="mt-6 text-[18px] font-sora font-semibold text-new-black-1000 text-center md:text-[18px] ">
        {props.event?.title ?? ""}
      </p>
      <div className="hidden sm:block">
        {props.event?.schedules.map((item, index) => {
          return (
            <div className="border border-border m-5 p-[10px] rounded-md">
              <p className="font-sora font-semibold text-[14px] mb-[10px]">
                {item.label}
              </p>
              <div className=" items-center justify-center">
                <div>
                  <div className="flex gap-2.5">
                    <div className="h-4 w-4 rounded-full center">
                      <FaCalendarAlt className="text-[12px] text-light-green-600" />
                    </div>
                    <p className="text-new-black-500 text-sm ">
                      {moment(item.date).format("DD MMM YYYY")}{" "}
                      {moment(item.start_time, "HH:mm:ss").format("HH:mm A")} -{" "}
                      {moment(item.end_time, "HH:mm:ss").format("HH:mm A")}
                    </p>
                  </div>
                  <div className="flex gap-2.5 mt-[10px]">
                    <div className="h-4 w-4 rounded-full center">
                      <FaMapMarkerAlt className="text-sm text-light-green-600" />
                    </div>
                    <p className="text-new-black-500 text-sm ">
                      {Boolean(item?.is_community_event)
                        ? `${item?.location ?? ""} ${item?.city ?? ""} ${
                            item?.state ?? ""
                          }`
                        : `${item?.address_line_1 ?? ""} ${
                            item?.address_line_2 ?? ""
                          } ${item?.city ?? ""} ${item?.state ?? ""}`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const REMAPage = () => {
  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  const location = useLocation();
  const event_id = getQueryParam("event_id", location.search);

  // const { event_id } = useParams();
  // console.log(event_id);

  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataFetchFailed, setDataFetchFailed] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    fetchEventData();
  }, []);

  const fetchEventData = async () => {
    try {
      setLoading(true);

      const params = {
        event_id: event_id ?? "",
      };

      const res = await fetch_event(params);
      const response = await res.json();
      console.log("event", response);
      setLoading(false);
      if (res.ok) {
        setDataFetchFailed(false);
        setEvent(response.data);
        console.log("event", response.data);
      } else {
        setDataFetchFailed(true);
        setErrMsg(response?.message);
      }
    } catch (error) {
      setDataFetchFailed(true);
      setErrMsg("Oops... Something went wrong");
    }
  };

  return (
    <>
      <Helmet>
        <title>
          RSVP Now - Venco Events | All-in-one Community Management Software
        </title>
        <meta
          property="og:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
        <meta
          name="twitter:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
      </Helmet>
      {/* <NavBarDark /> */}
      <FormPageNavbar />
      <div className="bg-[#F1F1F1]">
        <section className="lg:container mx-auto my-10 xl:py-[100px] lg:py-24">
          <div className="flex flex-col lg:flex-row lg:gap-7 h-full  xl:max-w-[1328px] xl:justify-between xl:mx-auto">
            {/* Form Image Section */}
            {/* <EventDetails event={event} /> */}
            <REMAEventDetails />

            <RSVPForm event={event} eventID={event_id} isRema />
          </div>
        </section>
      </div>

      <Footer />
      <MobileFooter />
    </>
  );
};

export default REMAPage;
